import { useGetVersion } from '@vlabs/api/artemy/client';

function useLicense() {
  const { data } = useGetVersion();

  return {
    isFeatureAvailable: () => true,
    versionNum: data?.Version ?? { major: 0, minor: 0, patch: 0 },
  };
}

export { useLicense };
